/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-03-02",
    versionChannel: "nightly",
    buildDate: "2024-03-02T00:05:25.161Z",
    commitHash: "8b8d028816e6a04a8ce48e6352a804334bbd6ec2",
};
